import { Flex } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import { OrganizationRow } from 'components/tables/data/organization/types';
import P3Medium from 'components/typography/P3Medium';

type ModuleEnabledValue = OrganizationRow['organizationPriceOffersEnabled'];

/**
 * Column for an organization module enabled indicator.
 */
export default function ModuleEnabledColumn({ value }: { value: ModuleEnabledValue }) {
  const enabled = value === 'Áno';
  const style = {
    borderRadius: '40px',
  };

  return (
    <Flex bg={enabled ? 'green.0' : 'red.0'} gap={4} py={0} pl={4} pr={8} align="center" style={style}>
      {enabled ? <IconCheck size={16} color="#2F9E44" /> : <IconX size={16} color="#C92A45" />}
      <P3Medium color={enabled ? 'green.9' : 'red.9'}>{value}</P3Medium>
    </Flex>
  );
}
